import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { CommonModule } from '@angular/common';
import { AssignmentHistoryComponent } from 'shared/components/assignment-history/assignment-history.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { AssignmentHistoryItemComponent } from 'shared/components/assignment-history/assignment-history-item/assignment-history-item.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule,
    LoadingModule
  ],
  declarations: [
    AssignmentHistoryComponent,
    AssignmentHistoryItemComponent
  ],
  exports: [
    AssignmentHistoryComponent
  ]
})
export class AssignmentHistoryModule {}
